export default "__VITE_ASSET__19d20ab5__"